<template>
  <v-dialog
    v-model="visible"
    width="90%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
  >
    <v-card class="pa-0 ma-0" rounded="xl" :height="sideHeight">
      <v-card-title class="primary white--text">
        Einstellungen - {{ navPoints.find(item => item.value === select).bezeichnung }}
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"><v-icon class="white--text">close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="2" class="mt-4">
            <v-card outlined>
              <v-navigation-drawer permanent floating>
                <v-list dense nav>
                  <v-list-item v-for="(item, index) in navPoints" :key="index" link @click="select = item.value" :class="select === item.value ? 'grey lighten-3' : ''">
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.bezeichnung }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </v-card>
          </v-col>
          <v-col cols="10">
            <Nutzerverwaltung v-if="select === 'nutzerverwaltung'" class="mt-4"></Nutzerverwaltung>
            <Allgemein v-if="select === 'allgemein'" class="mt-4"></Allgemein>
            <Design v-if="select === 'design'" class="mt-4"></Design>
            <Kontakte v-if="select === 'kontakte'" class="mt-4"></Kontakte>
            <Gruppen v-if="select === 'gruppen'" class="mt-4"></Gruppen>
            <Kassen v-if="select === 'kassen'" class="mt-4"></Kassen>
            <Kalender v-if="select === 'kalender'" class="mt-4"></Kalender>
            <Rollen v-if="select === 'rollen'" class="mt-4"></Rollen>
            <Templates v-if="select === 'templates'" class="mt-4"></Templates>
            <ImExport v-if="select === 'imexport'" class="mt-4"></ImExport> 
          </v-col>
        </v-row>          
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import Allgemein from './Allgemein.vue'
  import Design from './Design.vue'
  import Kontakte from './Kontakte.vue'
  import Rollen from './Rollen.vue'
  import Kassen from './Kassen.vue'
  import Kalender from './Kalender.vue'
  import Templates from './Templates.vue'
  import ImExport from './ImExport.vue'
  import Nutzerverwaltung from './Nutzerverwaltung.vue'
  import Gruppen from './Gruppen.vue'
  export default {
    props: ['visible'],
    components: {
      Allgemein,
      Design,
      Kontakte,
      Rollen,
      Kassen,
      Kalender,
      Templates,
      ImExport,
      Nutzerverwaltung,
      Gruppen
    },
    data () {
      return {
        select: 'nutzerverwaltung',
        navPoints: [
          { value: 'nutzerverwaltung', bezeichnung: 'Nutzerverwaltung', icon: 'groups' },
          { value: 'allgemein', bezeichnung: 'Allgemein', icon: 'settings' },
          { value: 'design', bezeichnung: 'Design', icon: 'brush' },
          { value: 'kontakte', bezeichnung: 'Kontakte', icon: 'group' },
          { value: 'gruppen', bezeichnung: 'Gruppen', icon: 'group' },
          { value: 'kassen', bezeichnung: 'Kassen', icon: 'group' },
          { value: 'kalender', bezeichnung: 'Kalender', icon: 'today' },
          { value: 'rollen', bezeichnung: 'Rollen', icon: 'description' },
          { value: 'templates', bezeichnung: 'Templates', icon: 'today' },
          { value: 'imexport', bezeichnung: 'Im-/Export', icon: 'import_export' }
        ]
      }
    },
    computed: {
      sideHeight () {
        if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 'calc(100vh - 191px)'
            case 'sm': return 'calc(100vh - 179px)'
            case 'md': return 'calc(100vh - 199px)'
            case 'lg': return 'calc(100vh - 191px)'
            case 'xl': return 'calc(100vh - 191px)'
          }
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 'calc(100vh - 199px)'
            case 'sm': return 'calc(100vh - 199px)'
            case 'md': return 'calc(100vh - 199px)'
            case 'lg': return 'calc(100vh - 199px)'
            case 'xl': return 'calc(100vh - 199px)'
          }
        }
      }
    },
    methods: {
      close () {
        this.$emit('close', false)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// einstellungen.vue?288d2727